import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  addSpaceOnLeft: {
    paddingLeft: '5px'
  },
  resizeIcon: {
    fontSize: 'medium'
  }
});
